import { createContactsModule } from '@izimi/modules';

import { contactsApi } from '../di';

export const contactsModule = createContactsModule({ contactsApi });
